import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, Search, HelpCircle, Home, Users, FileText, Shield, Copy, X, Filter, ArrowUpRight, ArrowLeft, Bot, ClipboardList } from 'lucide-react';
import { CreatePolicyModal } from './components/CreatePolicyModal';
import { CreditApplication } from './components/CreditApplication';
import { WonkaCreditApplication } from './components/WonkaCreditApplication';
import { InitechCreditApplication } from './components/InitechCreditApplication';
import { AdminDashboard } from './components/AdminDashboard';
import { AdvancedSearch } from './components/AdvancedSearch';
import { MonitorPage } from './components/MonitorPage';
import { ApplicationHub } from './components/ApplicationHub';
import { GlobalSearch } from './components/GlobalSearch';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [policyCreated, setPolicyCreated] = useState(false);
  const [currentPage, setCurrentPage] = useState<'policies' | 'application' | 'admin' | 'search' | 'monitor' | 'applicationHub'>('monitor');
  const [showStartArrow, setShowStartArrow] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState<'dunder' | 'wonka' | 'initech'>('dunder');
  const handleOpenModal = () => {
    setIsModalOpen(true);
    setShowStartArrow(false);
  };
  const handleCloseModal = (created?: boolean) => {
    setIsModalOpen(false);
    if (created) {
      setPolicyCreated(true);
    }
  };
  const handleCompanyClick = (company: 'dunder' | 'wonka' | 'initech') => {
    setSelectedCompany(company);
    setCurrentPage('application');
  };
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-0" data-mp="3dl4k1ljnffut">
      {/* Sidebar */}
      <div className="w-16 bg-white border-r border-gray-200 flex flex-col items-center py-6 space-y-6 z-20" data-id="element-1" data-mp="nvst52eusjuw">
        <button onClick={() => setCurrentPage('monitor')} className={`p-2 rounded-lg transition-colors ${currentPage === 'monitor' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-2" data-mp="su427axbqqc2">
          <Home className="w-5 h-5" data-id="element-3" data-mp="3uc9i9u1ffii8" />
        </button>
        <button onClick={() => setCurrentPage('search')} className={`p-2 rounded-lg transition-colors ${currentPage === 'search' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-4" data-mp="d57g95652mk4">
          <Search className="w-5 h-5" data-id="element-5" data-mp="3gm65dtoft15g" />
        </button>
        <button onClick={() => setCurrentPage('applicationHub')} className={`p-2 rounded-lg transition-colors ${currentPage === 'applicationHub' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-6" data-mp="3bmjq7ep1tau0">
          <ClipboardList className="w-5 h-5" data-id="element-7" data-mp="3liwl2fwbxuqc" />
        </button>
        <div className="relative" data-id="element-8" data-mp="2xudec4sxhq0d">
          {policyCreated && currentPage === 'policies' && <motion.div animate={{
          x: [0, 8, 0]
        }} transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute left-full ml-4 top-1/2 -translate-y-1/2 flex items-center gap-1.5 whitespace-nowrap" data-id="element-9" data-mp="2swbu3gjrnknb">
              <ArrowLeft className="w-5 h-5 text-gray-900 -mr-1" data-id="element-10" data-mp="13eocs71y913q" />
              <span className="bg-gray-900 text-white text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg" data-id="element-11" data-mp="13ey4bz2n7gbj">
                Go here
              </span>
            </motion.div>}
          <button onClick={() => setCurrentPage('application')} className={`p-2 rounded-lg transition-colors ${currentPage === 'application' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-12" data-mp="1w2txitt06q3k">
            <FileText className="w-5 h-5" data-id="element-13" data-mp="6onpkch8asoj" />
          </button>
        </div>
        <button onClick={() => setCurrentPage('policies')} className={`p-2 rounded-lg transition-colors ${currentPage === 'policies' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-14" data-mp="6qs55rohpg4n">
          <Shield className={`w-5 h-5 ${currentPage === 'policies' ? 'fill-indigo-100' : ''}`} data-id="element-15" data-mp="m5xa1b8jzj1j" />
        </button>
        <button onClick={() => setCurrentPage('admin')} className={`p-2 rounded-lg transition-colors ${currentPage === 'admin' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-16" data-mp="h7vmad06mvjq">
          <Bot className="w-5 h-5" data-id="element-17" data-mp="19tndivc7fge4" />
        </button>
        <div className="flex-1" data-id="element-18" data-mp="14y85wl4sigq5" />
        <button className="text-gray-600 hover:text-gray-900" data-id="element-19" data-mp="14utzn1t09ndf">
          <Users className="w-5 h-5" data-id="element-20" data-mp="zwiqyueg5iws" />
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-21" data-mp="vv71covkoxol">
        {/* Top Navbar */}
        <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center gap-4 z-10" data-id="element-22" data-mp="3kob3mdmjo24r">
          <button className="text-gray-600 hover:text-gray-900" data-id="element-23" data-mp="3glehwe1pjpwl">
            <Menu className="w-6 h-6" data-id="element-24" data-mp="1w4ezeced2rhs" />
          </button>

          <img src="https://cdn.magicpatterns.com/uploads/qJVgA9PEfqwGLDv8KygeAy/Property_1Creit_Pulse_Logo_black_2_(16).png" alt="Credit Pulse" className="h-8 object-contain" data-id="element-25" data-mp="1w5zuc34l8cg6" />

          <GlobalSearch onAddComplete={() => setCurrentPage('application')} data-id="element-26" data-mp="253a75sx209n7" />

          <div className="flex items-center gap-3" data-id="element-27" data-mp="29x4quwcnsoma">
            <button className="w-10 h-10 rounded-full border-2 border-indigo-400 flex items-center justify-center text-indigo-600 hover:bg-indigo-50" data-id="element-28" data-mp="2evg29bilr76m">
              <HelpCircle className="w-5 h-5" data-id="element-29" data-mp="2jw40ah590oac" />
            </button>
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium" data-id="element-30" data-mp="2nwwapdpuwz87">
              IN
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto" data-id="element-31" data-mp="tj4v7xkujl4u">
          {currentPage === 'monitor' ? <MonitorPage onCompanyClick={company => handleCompanyClick(company as 'dunder' | 'wonka' | 'initech')} data-id="element-32" data-mp="yh6mh5sfeqre" /> : currentPage === 'admin' ? <AdminDashboard data-id="element-33" data-mp="1wuk9rdbqp1i0" /> : currentPage === 'search' ? <AdvancedSearch onResultClick={() => {
          setSelectedCompany('dunder');
          setCurrentPage('application');
        }} data-id="element-34" data-mp="2at1rmueyrjs0" /> : currentPage === 'applicationHub' ? <ApplicationHub onViewApplication={() => {
          setSelectedCompany('dunder');
          setCurrentPage('application');
        }} data-id="element-35" data-mp="2ko3hjsh2cpvn" /> : currentPage === 'application' ? selectedCompany === 'wonka' ? <WonkaCreditApplication data-id="element-36" data-mp="2phy7hdn9i136" /> : selectedCompany === 'initech' ? <InitechCreditApplication data-id="element-37" data-mp="33h7epnthpkv0" /> : <CreditApplication data-id="element-38" data-mp="2yimcxjylat4g" /> : currentPage === 'policies' ? <div className="px-8 py-6 max-w-7xl mx-auto" data-id="element-39" data-mp="3i33fnbyxseuc">
              <div className="flex items-center justify-between mb-6" data-id="element-40" data-mp="3i1jvhaa5tjna">
                <div data-id="element-41" data-mp="3n1eqnq0ywve5">
                  <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-42" data-mp="3n0n392hiy3yy">
                    Credit Policy Management
                  </h1>
                  <p className="text-gray-600" data-id="element-43" data-mp="3d40iset41exg">
                    Manage policies for New and Existing customers
                  </p>
                </div>
                <div className="relative" data-id="element-44" data-mp="2zb269fojd66o">
                  {showStartArrow && !isModalOpen && <motion.div animate={{
                y: [0, -8, 0]
              }} transition={{
                duration: 1.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute -bottom-14 right-0 flex items-center gap-1.5 whitespace-nowrap" data-id="element-45" data-mp="345ydhn2cg04d">
                      <span className="bg-gray-900 text-white text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg" data-id="element-46" data-mp="30vx01kpizdfz">
                        Click here to start
                      </span>
                      <ArrowUpRight className="w-5 h-5 text-gray-900 -ml-1 -mt-4" data-id="element-47" data-mp="2qwxvad7vs1y9" />
                    </motion.div>}
                  <button onClick={handleOpenModal} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium relative z-10" data-id="element-48" data-mp="2lxbfpx4ky9ma">
                    <span className="text-lg" data-id="element-49" data-mp="2d3yca18w3ply">+</span>
                    New Policy
                  </button>
                </div>
              </div>

              {/* Tabs */}
              <div className="border-b border-gray-200 mb-6" data-id="element-50" data-mp="239g6mqjwxjzi">
                <div className="flex gap-8" data-id="element-51" data-mp="1y7h2hegcmj1i">
                  <button className="pb-3 px-1 border-b-2 border-indigo-600 text-indigo-600 font-medium" data-id="element-52" data-mp="1yamvv5w0g731">
                    New Customer Policies
                  </button>
                  <button className="pb-3 px-1 text-gray-600 hover:text-gray-900 font-medium" data-id="element-53" data-mp="9ocv0rdi1c6e">
                    Existing Customer Policies
                  </button>
                </div>
              </div>

              {/* Search and Filter */}
              <div className="flex gap-4 mb-8" data-id="element-54" data-mp="nof9s4qifphf">
                <div className="relative flex-1 max-w-sm" data-id="element-55" data-mp="no5kkjdahmcs">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-56" data-mp="3m6t7njbjauqg" />
                  <input type="text" placeholder="Search policies" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" data-id="element-57" data-mp="3r4memeknvsrs" />
                </div>
                <button className="px-4 py-2 border border-gray-300 rounded-lg flex items-center gap-2 text-gray-700 hover:bg-gray-50 font-medium" data-id="element-58" data-mp="33es5o83gqoct">
                  <Filter className="w-4 h-4" data-id="element-59" data-mp="38cjuuucq3wdb" />
                  Show Default Only
                </button>
              </div>

              {/* Policy Cards Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-60" data-mp="2k4n8fxrkx48f">
                {/* Default Policy Card */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-61" data-mp="2p3gonxy939ca">
                  <div className="flex items-start justify-between mb-4" data-id="element-62" data-mp="2u21o3v5ohozo">
                    <div data-id="element-63" data-mp="1wi70av3ec0ys">
                      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-64" data-mp="1wesxjlqtlpqt">
                        Credit Pulse Default Policy
                      </h3>
                      <div className="flex items-center gap-2 mb-3" data-id="element-65" data-mp="26e1mg06twe6b">
                        <span className="px-2 py-1 text-xs font-medium text-teal-700 bg-teal-50 border border-teal-200 rounded" data-id="element-66" data-mp="2b61smadhs3bc">
                          Default
                        </span>
                        <span className="px-2 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded" data-id="element-67" data-mp="1ioz8b2bel3gk">
                          v1
                        </span>
                      </div>
                    </div>
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-68" data-mp="3rxnin0dd3sc7">
                      <Copy className="w-5 h-5" data-id="element-69" data-mp="3mykav85zz80j" />
                    </button>
                  </div>

                  <div className="space-y-1 mb-4 text-sm text-gray-600" data-id="element-70" data-mp="3hzzjzzcmy0or">
                    <p data-id="element-71" data-mp="3i23nig6mgxoi">Type: New Customer</p>
                    <p data-id="element-72" data-mp="3d0wdsbkx5of7">
                      Last updated on Mar 27, 2026 by Integration Testing User
                    </p>
                  </div>

                  <button className="w-full bg-white border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 py-2.5 rounded-lg font-medium" data-id="element-73" data-mp="387tmyb7j0t2p">
                    Manage Policy &gt;
                  </button>
                </div>

                {/* New Policy Card */}
                <AnimatePresence data-id="element-74" data-mp="2u9n6m8ymfbqs">
                  {policyCreated && <motion.div initial={{
                opacity: 0,
                scale: 0.9,
                y: 20
              }} animate={{
                opacity: 1,
                scale: 1,
                y: 0
              }} className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-75" data-mp="2pc3gaaonf8ih">
                      <div className="flex items-start justify-between mb-4" data-id="element-76" data-mp="2ydxoon9jb63n">
                        <div data-id="element-77" data-mp="2yg0ou04eifm3">
                          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-78" data-mp="33cr2yhwnb14v">
                            My Company's Credit Policy
                          </h3>
                          <div className="flex items-center gap-2 mb-3" data-id="element-79" data-mp="2pjjcwuo7qdpa">
                            <span className="px-2 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded" data-id="element-80" data-mp="2tlo4lnv3p09a">
                              v1
                            </span>
                          </div>
                        </div>
                        <button className="text-gray-400 hover:text-gray-600" data-id="element-81" data-mp="1aojg2lvowst0">
                          <Copy className="w-5 h-5" data-id="element-82" data-mp="1amgh3cck7pc5" />
                        </button>
                      </div>

                      <div className="space-y-1 mb-4 text-sm text-gray-600" data-id="element-83" data-mp="15nlx472uvuqg">
                        <p data-id="element-84" data-mp="1kdksk2310s28">Type: New Customer</p>
                        <p data-id="element-85" data-mp="1feq4akmaibaq">Last updated on Mar 29, 2026 by You</p>
                      </div>

                      <button className="w-full bg-white border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 py-2.5 rounded-lg font-medium" data-id="element-86" data-mp="rp5hfqn0mtw6">
                        Manage Policy &gt;
                      </button>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div> : <CreditApplication data-id="element-87" data-mp="wquutcxpnjnf" />}
        </main>
      </div>

      {/* Modal */}
      {isModalOpen && <CreatePolicyModal onClose={handleCloseModal} data-id="element-88" data-mp="2d4useh932x7i" />}
    </div>;
}